import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Dahisartopunecab() {



const cardData = {
  keyword: " Dahisar to Pune Cabs",

headingDescription: "Velocity Cab provides reliable and comfortable Dahisar to Pune cab services, ensuring a smooth and hassle-free journey for business trips, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Dahisar to Pune convenient and stress-free. The journey covers approximately 150–160 km via the Mumbai–Pune Expressway, typically taking 3–4 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Dahisar to Pune cab travel.",

topPlaces: [
 
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of the most revered temples in Pune dedicated to Lord Ganesha. Visitors arriving from Dahisar often visit the temple to seek blessings and experience the vibrant spiritual atmosphere. The temple is beautifully decorated throughout the year and becomes a major attraction during Ganesh Chaturthi celebrations. Nearby markets also offer sweets, flowers, and religious items."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva and carved entirely from a single rock. Located in central Pune, it is known for its unique architecture and peaceful ambiance. Travelers from Dahisar can explore the temple’s stone pillars and carvings while enjoying a calm spiritual environment that is ideal for meditation and photography."
  },
   {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is one of Pune’s most iconic historical landmarks and once served as the residence of the Peshwas of the Maratha Empire. Travelers arriving from Dahisar by cab can explore its impressive entrance gates, strong fort walls, and the ruins of the royal palace complex. The site also features an evening light and sound show that narrates the fascinating history of the Maratha dynasty. Visitors often enjoy walking through the historic grounds, taking photographs, and learning about Pune’s rich cultural heritage."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument in Pune closely connected with Mahatma Gandhi and the Indian freedom movement. Travelers from Dahisar can admire its elegant Italian-style architecture, beautifully maintained gardens, and museum displaying historical artifacts. The peaceful surroundings make it an ideal destination for sightseeing, photography, and learning about India’s struggle for independence."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a famous hill fort located near Pune, known for its historical importance and scenic views. Travelers from Dahisar can take a short trip to this fort to enjoy trekking trails, explore ancient gates and bastions, and experience breathtaking views of the Sahyadri mountains. The fort is also popular for traditional Maharashtrian food like pithla bhakri served at local stalls."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum is one of Pune’s most interesting cultural attractions, showcasing thousands of artifacts that represent Indian heritage and craftsmanship. Travelers from Dahisar can explore exhibits featuring musical instruments, sculptures, decorative objects, and traditional household items. The museum offers a fascinating insight into India’s art, culture, and historical lifestyle."
  },
  {
    title: "Parvati Hill Temple",
    description: "Parvati Hill Temple is one of the oldest heritage sites in Pune and provides panoramic views of the city. Travelers arriving from Dahisar can climb the steps leading to the temple complex dedicated to Lord Shiva and other deities. The hilltop location is perfect for photography, sightseeing, and enjoying peaceful moments while overlooking the city skyline."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic water reservoir located on the outskirts of Pune and is a popular destination for nature lovers. Travelers from Dahisar can enjoy beautiful lake views, refreshing breezes, and picturesque sunsets. The dam area is ideal for picnics, photography, and relaxing walks while enjoying the surrounding hills and natural landscape."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully designed Japanese-style garden in Pune. Visitors arriving from Dahisar can stroll through its landscaped pathways, admire lotus ponds, bonsai trees, and lush greenery. The calm and scenic environment makes it a perfect place for relaxation, nature walks, and photography."
  },
  {
    title: "Lal Mahal",
    description: "Lal Mahal is a historic palace associated with the childhood of Chhatrapati Shivaji Maharaj and is an important cultural landmark in Pune. Travelers from Dahisar can explore the reconstructed palace which features sculptures and exhibits depicting scenes from Shivaji Maharaj’s life. It offers visitors an opportunity to learn about Maratha history and the cultural heritage of Pune."
  }
],



services: [
{
name: "Dahisar to Pune Cab",
description: "Dahisar to Pune cab service provides reliable and comfortable intercity travel for passengers looking for safe and hassle-free transportation. This service is ideal for both personal and business trips with well-maintained vehicles and experienced drivers. Customers can choose from sedan, SUV, and premium cab options based on their requirements. Timely pickup and drop ensure a smooth journey. Transparent pricing with no hidden charges helps in easy budget planning. Flexible booking options make travel convenient. It is one of the most preferred cab services for Dahisar to Pune travel."
},
{
name: "Dahisar to Pune Cab Service",
description: "Dahisar to Pune cab service offers dependable travel solutions for long-distance journeys with comfort and safety. This service includes multiple vehicle options such as sedan, SUV, and Innova for a better travel experience. Professional drivers ensure smooth highway driving and timely pickups. Transparent billing ensures clarity in pricing. Flexible pickup and drop locations add convenience for customers. Suitable for one way and round trips. It ensures a stress-free travel experience."
},
{
name: "Dahisar to Pune Taxi Service",
description: "Dahisar to Pune taxi service provides affordable and convenient travel for passengers looking for reliable transportation. Vehicles are clean and well-maintained ensuring comfort during long journeys. Professional drivers ensure safe and timely service. Ideal for airport transfers, family trips, and business travel. Transparent pricing ensures no hidden charges. Easy booking options make it convenient for users. It is a trusted taxi service for Dahisar to Pune routes."
},
{
name: "Dahisar to Pune One Way Cab",
description: "Dahisar to Pune one way cab service is perfect for travelers looking for cost-effective travel without return charges. This service significantly reduces travel expenses compared to round trip bookings. Customers can choose from multiple vehicle options based on their comfort and budget. Professional drivers ensure safe and timely journeys. Transparent pricing ensures no hidden costs. Easy booking with instant confirmation adds convenience. It is ideal for one way travel."
},
{
name: "Dahisar to Pune Taxi Fare",
description: "Dahisar to Pune taxi fare is designed to be affordable and transparent for customers planning their travel. Pricing depends on vehicle type, trip type, and distance covered. Customers receive clear fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their needs. It is ideal for cost-conscious travelers."
},
{
name: "Dahisar to Pune Cab Booking",
description: "Dahisar to Pune cab booking offers a quick and easy way to reserve your cab for comfortable travel. Customers can book online or via phone with instant confirmation. Multiple vehicle options are available for different travel needs. Professional drivers ensure safe and timely pickups. Transparent pricing ensures clarity in billing. Flexible scheduling allows easy travel planning. It ensures a hassle-free booking experience."
},
{
name: "Cab from Dahisar to Pune",
description: "Cab from Dahisar to Pune provides convenient and reliable transportation for intercity travel. This service is suitable for family trips, corporate travel, and personal journeys. Vehicles are well-maintained and equipped for long-distance travel. Professional drivers ensure smooth and safe rides. Flexible booking options make planning easy. Transparent pricing ensures no hidden charges. It is a trusted option for traveling between Dahisar and Pune."
},
{
name: "Dahisar to Pune Car Rental",
description: "Dahisar to Pune car rental service offers flexible travel options for customers who prefer private and comfortable journeys. Customers can choose from a wide range of vehicles including sedan, SUV, and premium cars. Well-maintained vehicles ensure a smooth ride. Professional drivers enhance safety and convenience. Transparent pricing ensures clear billing. Flexible rental plans suit different travel needs. It is ideal for both short and long-distance trips."
},
{
name: "Dahisar to Pune Taxi Booking Online",
description: "Dahisar to Pune taxi booking online provides a convenient way to book your cab from anywhere with instant confirmation. Customers can compare vehicle options and fares easily before booking. Professional drivers ensure safe and timely service. Transparent pricing ensures no hidden charges. Flexible booking options enhance convenience. It is the best option for quick and easy online cab booking."
},
{
name: "Cheap Cab Dahisar to Pune",
description: "Cheap cab Dahisar to Pune offers budget-friendly travel options for passengers looking for economical rides. This service ensures comfortable travel at affordable prices. Vehicles are clean and well-maintained for safe journeys. Professional drivers ensure smooth travel experience. Transparent pricing ensures no hidden costs. Flexible booking options make it convenient. It is ideal for budget-conscious travelers."
},
{
name: "Dahisar to Pune Outstation Cab",
description: "Dahisar to Pune outstation cab service provides reliable transportation for long-distance travel with comfort and safety. This service is suitable for family trips, corporate travel, and weekend getaways. Vehicles are maintained for highway journeys ensuring smooth rides. Professional drivers ensure safe and timely travel. Flexible options include one way and round trips. Transparent pricing ensures clear billing. It is a trusted choice for outstation travel."
},
{
name: "Dahisar to Pune AC Taxi Service",
description: "Dahisar to Pune AC taxi service offers comfortable and air-conditioned travel for passengers seeking a premium experience. This service ensures a pleasant journey even during long-distance travel. Vehicles are clean, well-maintained, and equipped with AC. Professional drivers ensure safe and smooth rides. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is ideal for comfortable travel."
},
{
name: "Dahisar to Pune Innova Cab",
description: "Dahisar to Pune Innova cab service provides spacious and comfortable travel for families and groups. This service is ideal for long-distance journeys with extra seating and luggage space. Vehicles are well-maintained and suitable for highway travel. Professional drivers ensure safe and smooth journeys. Transparent pricing ensures clarity in fares. Flexible booking options make it convenient. It is a preferred choice for group travel."
},
{
name: "Dahisar to Pune SUV Taxi",
description: "Dahisar to Pune SUV taxi service offers powerful and comfortable vehicles suitable for long-distance travel. This service is ideal for group travel and family trips. Vehicles provide ample space and smooth highway performance. Professional drivers ensure safe and timely service. Transparent pricing ensures no hidden costs. Flexible booking options enhance convenience. It is a great option for comfortable SUV travel."
},
{
name: "Dahisar to Pune Cab Price",
description: "Dahisar to Pune cab price is structured to offer affordable and transparent fares for all types of travelers. Pricing varies based on vehicle type, trip type, and travel requirements. Customers receive clear fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their needs. It helps in easy travel planning."
}
],

tableData: [
["Dahisar to Pune Cab","Dahisar to Pune Taxi Service"],
["Dahisar to Pune One Way Cab","Dahisar to Pune Cab Booking"],
["Cheap Cab Dahisar to Pune","Dahisar to Pune Outstation Cab"],
["Dahisar to Pune Innova Cab","Dahisar to Pune SUV Taxi"],
["Dahisar to Pune Cab Price","Cab from Dahisar to Pune"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Intercity Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Dahisar to Pune cab service for a smooth and comfortable journey via the Mumbai Pune Expressway, ideal for business trips, family travel, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Dahisar to Pune routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Dahisar to Pune cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Dahisar to Pune cab service operates 24/7. Whether you need early morning pickup or late-night travel, we ensure reliable cab availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and same-day return trips between Dahisar and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Dahisar to Pune cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Dahisar to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Dahisar to Pune for one-way and round-trip travel." },
  { question: "How far is Pune from Dahisar?", answer: "The distance between Dahisar and Pune is approximately 150 to 170 km and travel time is around 3.5 to 4.5 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Dahisar to Pune cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Dahisar to Pune." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Dahisar to Pune cabs online or through phone booking." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, societies, and offices across Dahisar." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and peak travel hours." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Patil",
    feedback:
      "My Dahisar to Pune trip with Velocity Cabs was very comfortable and well-coordinated. The cab arrived on time, the driver was experienced, and the journey was smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Deshmukh",
    feedback:
      "I had a pleasant experience traveling from Dahisar to Pune. The vehicle was clean, the pickup was on schedule, and the ride was safe and relaxing.",
    rating: 5
  }
];




















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const dahisarPuneCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Dahisar to Pune Cab | Velocity Cabs",
  "description": "Book a private cab from Dahisar to Pune for comfortable outstation travel. AC, Sedan, Innova, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Dahisar, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Dahisar to Pune Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Dahisar to Pune",
        "description": "Private cab from Dahisar to Pune for one-way travel with AC, SUV, Sedan, or Innova options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Dahisar to Pune Cab",
        "description": "Comfortable round-trip cab service from Dahisar to Pune with private AC, SUV, Sedan, or Innova options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};




  return (
    <div>
      
<Helmet>
  <title>Dahisar to Pune Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Dahisar to Pune for comfortable outstation travel. AC, Sedan, Innova, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(dahisarPuneCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/114.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Dahisartopunecab;